export var MODAL_ROOT_ELEMENT_SELECTOR="#modal-root";
//# sourceMappingURL=constants.js.map